import { Injectable } from '@angular/core';
import { environment } from 'src/environments';

@Injectable({
  providedIn: 'root'
})
export class IframeAdapterService {

  constructor() { }

  sendIframeHeight() {
    if(environment.production) {
      const elementHeight: number | any =
        document.getElementById('clave-web-pyme-content')?.scrollHeight;
      if (window.MessageChannel === undefined) {
        console.log('Navegador no habilitado para ajuste');
      } else {
        let mc = new MessageChannel();
        window.parent.postMessage(elementHeight, 'https://www.bci.cl', [
          mc.port1
        ]);
      }
    }
  }
}
